import { type TuFunction } from "@src/appV2/i18n/types";
import { fallbackTu } from "@src/appV2/i18n/fallbackTu";
interface QualificationOption {
  value: string;
  label: string;
}

export function buildPreShiftOrientationSummary(
  {
    orientationLengthInMinutes,
    qualifications,
    qualificationOptions,
  }: {
    orientationLengthInMinutes: number;
    qualifications: string[];
    qualificationOptions: QualificationOption[];
  },
  tu: TuFunction = fallbackTu
): string {
  const qualificationsLabel =
    qualifications.length === 0
      ? tu("any qualification")
      : qualifications
          .map(
            (value) => qualificationOptions.find((option) => option.value === value)?.label ?? value
          )
          .join(", ");
  return `${orientationLengthInMinutes} minutes for ${qualificationsLabel}`;
}
